import React from 'react';
import { Folder } from 'lucide-react';
import { getDisneyFolderIcon } from './DISNEY/folder-icons';
import { getResumidoFolderIcon } from './RESUMIDO/folder-icons';
import { getGPOVALLASFolderIcon } from './GPOVALLAS/folder-icons';
import { getTestFolderIcon } from './TEST/folder-icons';
import { getMacroFolderIcon } from './MACRO/folder-icons';

type ClientIconGetter = (sk: string) => React.ReactNode;

const CLIENT_ICON_GETTERS: Record<string, ClientIconGetter> = {
  TEST: getTestFolderIcon,
  DISNEY: getDisneyFolderIcon,
  RESUMIDO: getResumidoFolderIcon,
  GPOVALLAS: getGPOVALLASFolderIcon,
  MACRO: getMacroFolderIcon
};

export const getFolderIcon = (sk: string, clientId: string): React.ReactNode => {
  const getter = CLIENT_ICON_GETTERS[clientId];
  return getter ? getter(sk) : React.createElement(Folder, { size: 12 });
};
